"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextNoActiveConsultError = exports.NextInvalidInviteCodeError = exports.NextOnboardError = exports.NextInvalidTwoFactorCodeError = exports.NextLoginError = exports.NextSessionWeakPasswordError = exports.NextSessionInvalidatedError = exports.NextUnauthorizedError = exports.NextForbiddenError = exports.NextNotFoundError = void 0;
class NextNotFoundError extends Error {
    constructor(m = "Not found") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextNotFoundError.prototype);
    }
}
exports.NextNotFoundError = NextNotFoundError;
class NextForbiddenError extends Error {
    constructor(m = "Forbidden") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextForbiddenError.prototype);
    }
}
exports.NextForbiddenError = NextForbiddenError;
class NextUnauthorizedError extends Error {
    constructor(m = "Unauthorized") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextUnauthorizedError.prototype);
    }
}
exports.NextUnauthorizedError = NextUnauthorizedError;
class NextSessionInvalidatedError extends Error {
    constructor(m = "") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextSessionInvalidatedError.prototype);
    }
}
exports.NextSessionInvalidatedError = NextSessionInvalidatedError;
class NextSessionWeakPasswordError extends Error {
    constructor(m = "") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextSessionWeakPasswordError.prototype);
    }
}
exports.NextSessionWeakPasswordError = NextSessionWeakPasswordError;
class NextLoginError extends Error {
    constructor(m = "") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextLoginError.prototype);
    }
}
exports.NextLoginError = NextLoginError;
class NextInvalidTwoFactorCodeError extends Error {
    constructor(m = "") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextInvalidTwoFactorCodeError.prototype);
    }
}
exports.NextInvalidTwoFactorCodeError = NextInvalidTwoFactorCodeError;
// Generic error type with custom messages for onboard flow
// (see PatientAppModule onboard method for different messages)
class NextOnboardError extends Error {
    constructor(m = "") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextOnboardError.prototype);
    }
}
exports.NextOnboardError = NextOnboardError;
class NextInvalidInviteCodeError extends Error {
    constructor(m = "") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextInvalidInviteCodeError.prototype);
    }
}
exports.NextInvalidInviteCodeError = NextInvalidInviteCodeError;
class NextNoActiveConsultError extends Error {
    constructor(m = "") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NextNoActiveConsultError.prototype);
    }
}
exports.NextNoActiveConsultError = NextNoActiveConsultError;
//# sourceMappingURL=errorTypes.js.map